import React from 'react';

export default function CursoInfoScreen({ onNavigate }) {
  return (
    <div className="container2 public-page-shell">
      <header className="header public-header">
        <div className="public-header-content">
          <nav className="public-top-nav" aria-label="Navegação pública">
            <button type="button" className="public-top-link" onClick={() => onNavigate('login')}>
              Login
            </button>
            <button type="button" className="public-top-link active">
              Curso
            </button>
            <button type="button" className="public-top-link" onClick={() => onNavigate('desenho')}>
              Desenho
            </button>
          </nav>

          <h1 className="public-main-logo">
            <b className="bold">INK</b>
            <b className="rodriguez">RODRIGUEZ</b>
          </h1>
        </div>
      </header>

      <div className="container public-main-container">
        <section className="public-screen-section">
          <div className="public-screen-header">
            <span className="public-kicker">🎓 Curso Profissionalizante</span>
            <h2 className="public-screen-title">Mais do que aprender a tatuar.</h2>
            <p className="public-screen-subtitle">
              Uma formação completa pra você dominar técnica, projeto e mercado — com acompanhamento real.
            </p>

            <a
              href="https://www.instagram.com/ink.rodriguez/"
              target="_blank"
              rel="noreferrer"
              className="btn btn-outline public-instagram-btn"
            >
              Ver no Instagram
            </a>
          </div>

          <div className="public-metrics-grid">
            <div className="public-metric-card"><strong>26</strong><span>Encontros presenciais</span></div>
            <div className="public-metric-card"><strong>+30h</strong><span>Vídeo aulas</span></div>
            <div className="public-metric-card"><strong>2</strong><span>Tatuagens supervisionadas</span></div>
            <div className="public-metric-card"><strong>116h</strong><span>Carga horária total</span></div>
          </div>

          <div className="public-screen-content">
            <section className="public-content-section">
              <h3>📚 Estrutura (Atualizada)</h3>
              <ul className="public-bullet-list">
                <li>26 encontros presenciais (teoria + prática progressiva)</li>
                <li>30h de vídeo aulas complementares</li>
                <li>Estágio supervisionado com 2 tatuagens reais (mínimo 8h)</li>
                <li>1 dia de Shadow (acompanhar uma tatuagem feita por mim)</li>
                <li>Kit de Tatuagem Incluso</li>
                <li>Carga horária total do programa: 116 horas</li>
              </ul>
            </section>

            <section className="public-content-section">
              <h3>🗓️ Programa Presencial (26 Encontros)</h3>
              <p className="public-content-text">
                Aulas de 3h cada. Sequência pensada pra evoluir sem pular etapas.
              </p>

              <div className="public-content-groups">
                <div className="public-group-card">
                  <h4>🖊️ Base Artística</h4>
                  <ul className="public-bullet-list">
                    <li>Dia 1: Desenho (2D + 3D)</li>
                    <li>Dia 2: Perspectiva + encaixe de objetos</li>
                  </ul>
                </div>

                <div className="public-group-card">
                  <h4>🧼 Fundamentos Profissionais</h4>
                  <ul className="public-bullet-list">
                    <li>Dia 3: Biossegurança + pele</li>
                    <li>Dia 4: Máquinas e regulagem</li>
                    <li>Dia 5: Agulhas</li>
                  </ul>
                </div>

                <div className="public-group-card">
                  <h4>🔥 Prática na Pele Artificial</h4>
                  <ul className="public-bullet-list">
                    <li>Dia 6: Traços</li>
                    <li>Dia 7: Sombra Round Liner</li>
                    <li>Dia 8: Sombra Magnum</li>
                    <li>Dia 9: Preto sólido</li>
                    <li>Dia 10: Cor</li>
                    <li>Dia 11: Texturas</li>
                  </ul>
                </div>

                <div className="public-group-card">
                  <h4>🎨 Estilos (1 dia cada)</h4>
                  <ul className="public-bullet-list">
                    <li>Dia 12: Escritas / Fineline</li>
                    <li>Dia 13: Old School</li>
                    <li>Dia 14: New School</li>
                    <li>Dia 15: Blackwork</li>
                    <li>Dia 16: Realismo</li>
                    <li>Dia 17: Geek</li>
                    <li>Dia 18: Aquarela</li>
                    <li>Dia 19: Neo Tradicional</li>
                    <li>Dia 20: Pontilhismo</li>
                  </ul>
                </div>

                <div className="public-group-card">
                  <h4>🧴 Cliente / Aftercare</h4>
                  <ul className="public-bullet-list">
                    <li>Dia 21: Pré, durante e pós tattoo</li>
                  </ul>
                </div>

                <div className="public-group-card">
                  <h4>👀 Shadow (Aula Viva)</h4>
                  <ul className="public-bullet-list">
                    <li>Dia 22: Acompanhar uma tatuagem feita por mim</li>
                  </ul>
                </div>

                <div className="public-group-card">
                  <h4>🧠 Projeto + Prova Prática (novo modelo)</h4>
                  <ul className="public-bullet-list">
                    <li>Dia 23: Desenvolvimento de projeto</li>
                    <li>Dia 24: Dia do seu projeto (Prova prática completa)</li>
                  </ul>
                  <p className="public-content-text">
                    Simulação real: o estúdio te manda referências como “cliente”, você cria o projeto,
                    apresenta, prepara o processo e executa seguindo padrão profissional
                    (inclui confirmação de presença e pós-tattoo).
                  </p>
                </div>

                <div className="public-group-card">
                  <h4>💰 Precificação / Financeiro</h4>
                  <ul className="public-bullet-list">
                    <li>Dia 25: Pix, cartão, taxas, conta, maquininha, controle e margem</li>
                  </ul>
                </div>

                <div className="public-group-card">
                  <h4>🏁 Mercado e Profissionalização</h4>
                  <ul className="public-bullet-list">
                    <li>Dia 26: Captação, Instagram, postura, estúdio, residência e evolução</li>
                  </ul>
                </div>
              </div>
            </section>

            <section className="public-content-section">
              <h3>🩸 Estágio Supervisionado (Obrigatório)</h3>
              <ul className="public-bullet-list">
                <li>2 tatuagens reais supervisionadas</li>
                <li>Mínimo de 8 horas de prática em pele humana</li>
                <li>Deve conter: 1 linework + 1 sombra ou cor</li>
                <li>O certificado é entregue após a conclusão do estágio.</li>
              </ul>
            </section>

            <section className="public-content-section">
              <h3>🏆 Benefícios Inclusos</h3>
              <ul className="public-bullet-list">
                <li>Certificado A3 físico</li>
                <li>Apostila completa</li>
                <li>Material incluso até a conclusão</li>
                <li>30h de vídeo aulas</li>
                <li>Acompanhamento pós-curso</li>
                <li>Possibilidade de residência no Estúdio Shodō</li>
                <li>Kit incluso</li>
              </ul>
            </section>

            <section className="public-content-section">
              <h3>💰 Investimento</h3>

              <div className="public-pricing-grid">
                <div className="public-price-card">
                  <span>Pix/Dinheiro</span>
                  <strong>R$ 3.190,00</strong>
                </div>

                <div className="public-price-card">
                  <span>Cartão</span>
                  <strong>R$ 3.690,00</strong>
                </div>

                <div className="public-price-card">
                  <span>Parcelamento</span>
                  <strong>em até 12x sem juros</strong>
                </div>
              </div>

              <div className="public-cta-row">
                <a
                  href="https://wa.me/5524993087471"
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn-primary"
                >
                  Reservar agora
                </a>
              </div>

              <p className="public-footer-note">
                📍 Estúdio Shodō — Volta Redonda/RJ • Vagas limitadas
              </p>
            </section>
          </div>

          <p className="public-copyright">
            © 2025 INKRODRIGUEZ. Todos os direitos reservados.
          </p>
        </section>
      </div>
    </div>
  );
}